define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/Configuration',
	'internal_util/StorageUtil',
	'state/UIState',
	'model/AuthenticationOptionGroup',
	'model/RequestedAttribute',
	'service/UIStateManager',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ResolveCloudIDView',
	'view/ControlBarView',
        'view/TextView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/ResolveCloudIDState_strings'
], function (
	Util,
	UiUtil,
	Configuration,
	StorageUtil,
	UIState,
	AuthenticationOptionGroup,
	RequestedAttribute,
	UIStateManager,
	ProviderInfoView,
	NavigationView,
	ResolveCloudIDView,
	ControlBarView,
        TextView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ResolveCloudIDState class
	 */
	function ResolveCloudIDState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_resolveCloudIDView = new ResolveCloudIDView(),
			_controlBarView = new ControlBarView(),
			_nextButton,
                        _consentCheckBox,
			_activationData = null,
                        _cloudIdentitiesManager,
			_deleteCloudID = false,
                        _noIdentitiesTextView = (function () {
                            var textView = new TextView();

                            textView.addText(Strings.no_cloud_identity_available);

                            return textView;
                        })(),
                        _identitiesNotUsableTextView = (function () {
                            var textView = new TextView();

                            textView.addText(Strings.cloud_identity_not_usable);

                            return textView;
                        })(),
                        _deleteIdentitiesTextView = (function () {
                            var textView = new TextView();

                            textView.addText(Strings.delete_cloud_identity);

                            return textView;
                        })();;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.resolve_identity);

		_consentCheckBox = _controlBarView.addCheckBox(Strings.approval_checkbox, function (isChecked) {
			_nextButton.prop('disabled', !isChecked);
		});

		_controlBarView.addButton(CommonStrings.back, function () {
			if (_deleteCloudID) {
                            _resolveCloudIDView.changeContent(_identitiesNotUsableTextView);
                            _deleteCloudID = false;
                            _consentCheckBox.hide();
                            _nextButton.prop('disabled', false);
                            return;
                        }
                    
                        if (_activationData['fromSP']) {
				_uiStateManager.changeContext();
			} else {
				_uiStateManager.back();
			}
		}, 0);

		_nextButton = _controlBarView.addButton(CommonStrings.next, function () {
                    if (_deleteCloudID) {
                        var id = _cloudIdentitiesManager.identities()[0];
                        _cloudIdentitiesManager.deleteCloudIdentity(id);
                        _deleteCloudID = false;
                    }
                    
                    if (_cloudIdentitiesManager.identities().length === 0) {
						_uiStateManager.change('identity_creation', {
							authenticationOption : _activationData.authenticationOption,
							requestedAttributes : _activationData.requestedAttributes,
							fromSP : _activationData.fromSP
						});
                    } else {
                        _resolveCloudIDView.changeContent(_deleteIdentitiesTextView);
                        _consentCheckBox.show();
                        _nextButton.prop('disabled', true);
                        _deleteCloudID = true;
                    }
		});

		_controlBarView.addButton(CommonStrings.abort, function () {
			StorageUtil.remove('authentication_option');

			_uiStateManager.abort();
		});

		UIState.call(this, 'resolve_identity');


		// private methods


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _resolveCloudIDView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, activationData) {
			_cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager();
			_activationData = activationData;

			_providerInfoView.update(_cloudIdentitiesManager.providerInfo());
			_consentCheckBox.hide();

			if (_cloudIdentitiesManager.identities().length === 0) {
				_resolveCloudIDView.changeContent(_noIdentitiesTextView);
			} else {
				_resolveCloudIDView.changeContent(_identitiesNotUsableTextView);
			}
                        
//                        StorageUtil.remove('authentication_option');
//                        StorageUtil.remove('requested_attributes');

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			_activationData = null;

			Util.callCallbacks(doneCallback);
		};
	}

	ResolveCloudIDState.prototype = Object.create(UIState.prototype);

	return ResolveCloudIDState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/ResolveCloudIDState.js
// module id = 356
// module chunks = 2